export const ApiEndpoints = {
  leaderboardsFilters: () => "/v1/surehand/leaderboards/filters",
  leaderboards: () => "/v1/surehand/leaderboards",
  contactUs: () => "/v1/system/contact-us",
  profile: (id: number) => `/v1/surehand/profile/${id}`,
};
